<label>
    <ng-content></ng-content>
</label>
